module.exports = __webpack_public_path__ + "static/media/whiteLogo.3055ff7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/whiteLogo.svg
// module id = 812
// module chunks = 0